// Región de una agencia: la misma lista que la app (shared.REGIONS), por
// zonas y con el nombre del país de AgenciasRegionGeo. De ella salen el país
// del Explorador y la bandera de su pin en el mapa.

import { useMemo } from 'react';
import { Select, SelectItem, SelectSection } from '@nextui-org/react';
import { AgencyShared as S, RegionGeo } from '../../lib/agencyApp';

const placeName = (r) => (RegionGeo ? RegionGeo.placeName(r) : String(r).split(' / ')[1] || r);
const zoneName = (g) => (RegionGeo && RegionGeo.groupLabel(g)) || g;

function regionSections() {
  const groups = new Map();
  const loose = [];
  for (const r of S.REGIONS || []) {
    if (!String(r).includes(' / ')) { loose.push(r); continue; }
    const g = String(r).split(' / ')[0];
    if (!groups.has(g)) groups.set(g, []);
    groups.get(g).push(r);
  }
  return { groups: [...groups.entries()], loose };
}

export default function RegionSelect({ value, onChange, label = 'Región', size = 'sm', className }) {
  const regions = useMemo(regionSections, []);
  const known = !value || (S.REGIONS || []).includes(value);
  // Una región antigua que ya no está en la lista se sigue viendo.
  const first = [['__none', 'Sin configurar'], ...(known ? [] : [[value, value]])];
  return (
    <Select
      size={size}
      label={label}
      className={className}
      selectedKeys={value ? [value] : ['__none']}
      onSelectionChange={(keys) => {
        const v = String(Array.from(keys)[0] || '__none');
        onChange(v === '__none' ? '' : v);
      }}
    >
      <SelectSection>
        {first.map(([key, text]) => <SelectItem key={key}>{text}</SelectItem>)}
      </SelectSection>
      {regions.groups.map(([g, list]) => (
        <SelectSection key={g} title={zoneName(g)} showDivider>
          {list.map((r) => <SelectItem key={r} textValue={placeName(r)}>{placeName(r)}</SelectItem>)}
        </SelectSection>
      ))}
      <SelectSection>
        {regions.loose.map((r) => <SelectItem key={r}>{placeName(r)}</SelectItem>)}
      </SelectSection>
    </Select>
  );
}
